import React, { useEffect } from "react";
import OshaToken from "../component/oshaToken/oshaToken";
import { useSelector } from "react-redux";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../library/common/Loader";

const OshaTokenContainer = () => {
  const dispatch = useDispatch();

  const addOshaToken = useSelector((state) => state.addOshaToken);
  const oshaTokenDetails = useSelector((state) => state.getOshaTokenDetails);
  const showLoader = useSelector(
    (state) =>
      state.addOshaToken?.isLoading || state.getOshaTokenDetails?.isLoading
  );

  const onSubmit = (data) => {
    dispatch(adminAction.addOshaToken(data));
  };

  useEffect(() => {
    if (
      addOshaToken?.status === "SUCCESS" &&
      addOshaToken?.isLoading === false
    ) {
      toast("Osha Token Updated successfully");
      dispatch(adminAction.getOshaTokenDetails());
    }
  }, [addOshaToken]);

  useEffect(() => {
    dispatch(adminAction.getOshaTokenDetails());
  }, []);

  return (
    <>
      {showLoader && <Loader />}
      <OshaToken
        addOshaToken={addOshaToken}
        onSubmit={onSubmit}
        oshaTokenDetails={oshaTokenDetails}
      />
      <ToastContainer />
    </>
  );
};

export default OshaTokenContainer;
